var e={nextArrowLabel:"Next slide",prevArrowLabel:"Previous slide"};export{e as emblaCarouselTranslations};
